export const colors = {
    primaryColor: '#FC1921',
    linkTextColor: '#d2d2d2',
    borderColor: "rgb(219, 214, 214)",
    borderBtnColor: "#000000",
    mutedColor: '#6c757d',
    whiteColor: '#FFFFFF',
    authorColor: '#1C64CA',
}